module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step4_3-4aa17d86e6e92df56b58985fb149b2b6.png";